import { render, staticRenderFns } from "./UserSale.vue?vue&type=template&id=0f4d344d&"
import script from "./UserSale.vue?vue&type=script&lang=js&"
export * from "./UserSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports